{
  "familyId": "TGL-GELD-KORTING",
  "questions": [
    {
      "id": "TGL-GELD-KORTING-001",
      "familyId": "TGL-GELD-KORTING",
      "module": "TijdGeld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_korting",
      "questionType": "multiple_choice",
      "question": "Een fietsenmaker geeft 10% korting op een fiets van €80. Hoeveel korting krijg je?",
      "options": ["€8", "€72", "€10", "€70"],
      "correctAnswer": 0,
      "conceptId": "discount_amount_10pct",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.75,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Korting berekenen", "content": "Korting = percentage × prijs ÷ 100. Hier: 10% van €80 = 10 × 80 ÷ 100 = €8. Handig: 10% = delen door 10.", "icon": "lightbulb" } }
      ],
      "feedback": {
        "explanationText": "De fietsenmaker berekent: 10% is altijd het getal gedeeld door 10. Dus 10% van €80 = €80 ÷ 10 = €8 korting.",
        "solutionSteps": ["10% = delen door 10", "€80 ÷ 10 = €8 korting"],
        "distractorExplanations": {
          "0": "Goed! 10% van €80 = €80 ÷ 10 = €8.",
          "1": "Je dacht waarschijnlijk dat de vraag naar de nieuwe prijs vraagt. Maar €72 is de prijs na korting (€80 − €8). De vraag vraagt hoeveel korting je krijgt: €8. Onthoud: lees goed of de vraag naar het kortingsbedrag of de nieuwe prijs vraagt.",
          "2": "Je dacht waarschijnlijk dat het percentage gelijk is aan het bedrag. Maar 10% van €80 is €8, niet €10. €10 zou kloppen als de prijs €100 was. Onthoud: 10% = delen door 10.",
          "3": "Je dacht waarschijnlijk dat je €10 aftrekt. Maar 10% van €80 = €8, niet €10. Onthoud: 10% = delen door 10, niet het getal 10 aftrekken."
        }
      }
    },
    {
      "id": "TGL-GELD-KORTING-002",
      "familyId": "TGL-GELD-KORTING",
      "module": "TijdGeld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_korting",
      "questionType": "multiple_choice",
      "question": "Een kledingverkoper geeft 20% korting op een jas van €60. Wat is de nieuwe prijs?",
      "options": ["€48", "€12", "€40", "€80"],
      "correctAnswer": 0,
      "conceptId": "discount_final_price_20pct",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.73,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Nieuwe prijs na korting", "content": "Stap 1: Korting = 20% van €60 = €12. Stap 2: Nieuwe prijs = €60 − €12 = €48.", "icon": "lightbulb" } }
      ],
      "feedback": {
        "explanationText": "De kledingverkoper berekent eerst het kortingsbedrag en trekt dat af. 20% van €60 = 20 × 60 ÷ 100 = €12 korting. Nieuwe prijs = €60 − €12 = €48.",
        "solutionSteps": ["20% van €60 = €12 korting", "Nieuwe prijs = €60 − €12 = €48"],
        "distractorExplanations": {
          "0": "Goed! €60 − 20% = €60 − €12 = €48.",
          "1": "Je dacht waarschijnlijk dat €12 de nieuwe prijs is. Maar €12 is het kortingsbedrag, niet wat je betaalt. Je betaalt €60 − €12 = €48. Onthoud: korting aftrekken van de originele prijs.",
          "2": "Je dacht waarschijnlijk dat je €20 aftrekt. Maar 20% van €60 = €12, niet €20. Onthoud: het percentage is niet hetzelfde als het bedrag.",
          "3": "Je dacht waarschijnlijk dat je optelt. Maar bij korting trek je af: €60 − €12 = €48, niet €60 + €20 = €80. Onthoud: korting = aftrekken."
        }
      }
    },
    {
      "id": "TGL-GELD-KORTING-003",
      "familyId": "TGL-GELD-KORTING",
      "module": "TijdGeld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_korting",
      "questionType": "multiple_choice",
      "question": "Een boekhandelaar geeft 10% korting op een boek van €25. Hoeveel betaal je?",
      "options": ["€22,50", "€2,50", "€27,50", "€15"],
      "correctAnswer": 0,
      "conceptId": "discount_final_price_10pct",
      "variantIndex": 3,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "10% korting op €25", "content": "10% = delen door 10. €25 ÷ 10 = €2,50 korting. Nieuwe prijs = €25 − €2,50 = €22,50.", "icon": "lightbulb" } }
      ],
      "feedback": {
        "explanationText": "De boekhandelaar berekent: 10% van €25 = €25 ÷ 10 = €2,50 korting. Nieuwe prijs = €25 − €2,50 = €22,50.",
        "solutionSteps": ["10% van €25 = €25 ÷ 10 = €2,50", "Nieuwe prijs = €25 − €2,50 = €22,50"],
        "distractorExplanations": {
          "0": "Goed! €25 − €2,50 = €22,50.",
          "1": "Je dacht waarschijnlijk dat €2,50 de nieuwe prijs is. Maar €2,50 is de korting, niet wat je betaalt. Je betaalt €25 − €2,50 = €22,50. Onthoud: korting aftrekken van de originele prijs.",
          "2": "Je dacht waarschijnlijk dat je optelt. Maar bij korting trek je af: €25 − €2,50 = €22,50, niet €25 + €2,50 = €27,50. Onthoud: korting = aftrekken.",
          "3": "Je dacht waarschijnlijk dat 10% meer is. Maar 10% van €25 = €2,50, niet €10. Onthoud: 10% = delen door 10."
        }
      }
    },
    {
      "id": "TGL-GELD-KORTING-004",
      "familyId": "TGL-GELD-KORTING",
      "module": "TijdGeld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_korting",
      "questionType": "multiple_choice",
      "question": "Een speelgoedverkoper geeft 25% korting op een spelcomputer van €120. Hoeveel korting is dat?",
      "options": ["€30", "€90", "€25", "€95"],
      "correctAnswer": 0,
      "conceptId": "discount_amount_25pct",
      "variantIndex": 4,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "25% korting berekenen", "content": "25% = een kwart. Een kwart van €120 = €120 ÷ 4 = €30.", "icon": "lightbulb" } }
      ],
      "feedback": {
        "explanationText": "De speelgoedverkoper berekent: 25% = een kwart, dus deel door 4. 25% van €120 = €120 ÷ 4 = €30 korting.",
        "solutionSteps": ["25% = een kwart = delen door 4", "€120 ÷ 4 = €30 korting"],
        "distractorExplanations": {
          "0": "Goed! 25% van €120 = €120 ÷ 4 = €30.",
          "1": "Je dacht waarschijnlijk dat de vraag naar de nieuwe prijs vraagt. Maar €90 is de prijs na korting (€120 − €30). De vraag vraagt hoeveel korting: €30. Onthoud: lees goed wat de vraag vraagt.",
          "2": "Je dacht waarschijnlijk dat het percentage gelijk is aan het bedrag. Maar 25% van €120 = €30, niet €25. Onthoud: 25% = delen door 4, niet het getal 25.",
          "3": "Je dacht waarschijnlijk dat de korting €25 is. Maar 25% van €120 = €30, dus de nieuwe prijs is €90, niet €95. Onthoud: 25% = delen door 4."
        }
      }
    },
    {
      "id": "TGL-GELD-KORTING-005",
      "familyId": "TGL-GELD-KORTING",
      "module": "TijdGeld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_korting",
      "questionType": "multiple_choice",
      "question": "Een modezaak geeft 15% korting op een trui van €40. Wat betaal je?",
      "options": ["€34", "€6", "€46", "€25"],
      "correctAnswer": 0,
      "conceptId": "discount_final_price_15pct",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.71,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "15% korting op €40", "content": "Splits 15% in 10% + 5%. 10% van €40 = €4. 5% = helft van 10% = €2. Totaal: €4 + €2 = €6 korting. Nieuwe prijs = €40 − €6 = €34.", "icon": "lightbulb" } }
      ],
      "feedback": {
        "explanationText": "De modezaak berekent: splits 15% in 10% + 5%. 10% van €40 = €4. 5% = helft van 10% = €2. Totaal: 15% = €4 + €2 = €6 korting. Nieuwe prijs = €40 − €6 = €34.",
        "solutionSteps": ["10% van €40 = €4", "5% = helft van 10% = €2", "15% = €4 + €2 = €6 korting", "Nieuwe prijs = €40 − €6 = €34"],
        "distractorExplanations": {
          "0": "Goed! 15% van €40 = €6 korting. €40 − €6 = €34.",
          "1": "Je dacht waarschijnlijk dat €6 de nieuwe prijs is. Maar €6 is de korting, niet wat je betaalt. Je betaalt €40 − €6 = €34. Onthoud: korting aftrekken van de originele prijs.",
          "2": "Je dacht waarschijnlijk dat je optelt. Maar bij korting trek je af: €40 − €6 = €34, niet €40 + €6 = €46. Onthoud: korting = aftrekken.",
          "3": "Je dacht waarschijnlijk dat 15% meer is. Maar 15% van €40 = €6, niet €15. Onthoud: splits 15% in 10% + 5% voor makkelijker rekenen."
        }
      }
    },
    {
      "id": "TGL-GELD-KORTING-006",
      "familyId": "TGL-GELD-KORTING",
      "module": "TijdGeld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_korting",
      "questionType": "multiple_choice",
      "question": "Een tassenwinkel geeft 20% korting op een tas van €50. Hoeveel korting krijg je?",
      "options": ["€10", "€40", "€20", "€30"],
      "correctAnswer": 0,
      "conceptId": "discount_amount_20pct",
      "variantIndex": 6,
      "citoDifficulty": 0.27,
      "citoDiscrimination": 0.74,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "20% van €50", "content": "20% = een vijfde. Een vijfde van €50 = €50 ÷ 5 = €10.", "icon": "lightbulb" } }
      ],
      "feedback": {
        "explanationText": "De tassenwinkel berekent: 20% = een vijfde, dus deel door 5. 20% van €50 = €50 ÷ 5 = €10 korting.",
        "solutionSteps": ["20% = een vijfde = delen door 5", "€50 ÷ 5 = €10 korting"],
        "distractorExplanations": {
          "0": "Goed! 20% van €50 = €50 ÷ 5 = €10.",
          "1": "Je dacht waarschijnlijk dat de vraag naar de nieuwe prijs vraagt. Maar €40 is de prijs na korting (€50 − €10). De vraag vraagt hoeveel korting: €10. Onthoud: lees goed wat de vraag vraagt.",
          "2": "Je dacht waarschijnlijk dat het percentage gelijk is aan het bedrag. Maar 20% van €50 = €10, niet €20. Onthoud: 20% = delen door 5.",
          "3": "Je dacht waarschijnlijk dat de korting groter is. Maar 20% van €50 = €10, niet €30. Onthoud: 20% = delen door 5."
        }
      }
    },
    {
      "id": "TGL-GELD-KORTING-007",
      "familyId": "TGL-GELD-KORTING",
      "module": "TijdGeld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_korting",
      "questionType": "multiple_choice",
      "question": "Een winkelier verhoogt de prijs met 10% opslag. Een artikel kostte €30. Wat is de nieuwe prijs?",
      "options": ["€33", "€3", "€27", "€40"],
      "correctAnswer": 0,
      "conceptId": "surcharge_10pct",
      "variantIndex": 7,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.70,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Opslag berekenen", "content": "Opslag = percentage × prijs ÷ 100. 10% van €30 = €3. Nieuwe prijs = €30 + €3 = €33. Let op: bij opslag tel je erbij op!", "icon": "lightbulb" } }
      ],
      "feedback": {
        "explanationText": "De winkelier berekent: bij opslag tel je het percentage erbij op (niet aftrekken!). 10% van €30 = €30 ÷ 10 = €3 opslag. Nieuwe prijs = €30 + €3 = €33.",
        "solutionSteps": ["10% van €30 = €3 opslag", "Bij opslag tel je erbij op", "Nieuwe prijs = €30 + €3 = €33"],
        "distractorExplanations": {
          "0": "Goed! €30 + 10% = €30 + €3 = €33.",
          "1": "Je dacht waarschijnlijk dat €3 de nieuwe prijs is. Maar €3 is de opslag, niet wat je betaalt. Je betaalt €30 + €3 = €33. Onthoud: opslag optellen bij de originele prijs.",
          "2": "Je dacht waarschijnlijk dat je aftrekt. Maar bij opslag (prijsverhoging) tel je erbij op: €30 + €3 = €33, niet €30 − €3 = €27. Onthoud: opslag = optellen.",
          "3": "Je dacht waarschijnlijk dat 10% meer is. Maar 10% van €30 = €3, niet €10. Onthoud: 10% = delen door 10."
        }
      }
    },
    {
      "id": "TGL-GELD-KORTING-008",
      "familyId": "TGL-GELD-KORTING",
      "module": "TijdGeld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_korting",
      "questionType": "multiple_choice",
      "question": "Een restauranthouder rekent 10% servicekosten bij. De rekening is €45. Hoeveel betaal je in totaal?",
      "options": ["€49,50", "€4,50", "€40,50", "€55"],
      "correctAnswer": 0,
      "conceptId": "surcharge_service",
      "variantIndex": 8,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.71,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Servicekosten berekenen", "content": "10% van €45 = €4,50. Totaal = €45 + €4,50 = €49,50. Servicekosten worden opgeteld bij de rekening.", "icon": "lightbulb" } }
      ],
      "feedback": {
        "explanationText": "De restauranthouder berekent: servicekosten zijn een opslag — tel het percentage erbij op. 10% van €45 = €45 ÷ 10 = €4,50 servicekosten. Totaal = €45 + €4,50 = €49,50.",
        "solutionSteps": ["10% van €45 = €45 ÷ 10 = €4,50", "Servicekosten = opslag → optellen", "Totaal = €45 + €4,50 = €49,50"],
        "distractorExplanations": {
          "0": "Goed! €45 + 10% = €45 + €4,50 = €49,50.",
          "1": "Je dacht waarschijnlijk dat €4,50 het totaal is. Maar €4,50 zijn de servicekosten zelf, niet het totaal. Je betaalt €45 + €4,50 = €49,50. Onthoud: servicekosten optellen bij de rekening.",
          "2": "Je dacht waarschijnlijk dat je aftrekt. Maar servicekosten komen erbij: €45 + €4,50 = €49,50, niet €45 − €4,50 = €40,50. Onthoud: servicekosten = optellen.",
          "3": "Je dacht waarschijnlijk dat 10% meer is. Maar 10% van €45 = €4,50, niet €10. Onthoud: 10% = delen door 10."
        }
      }
    },
    {
      "id": "TGL-GELD-KORTING-009",
      "familyId": "TGL-GELD-KORTING",
      "module": "TijdGeld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_korting",
      "questionType": "multiple_choice",
      "question": "Een schoenmaker geeft 25% korting op schoenen van €80. Wat betaal je?",
      "options": ["€60", "€20", "€105", "€55"],
      "correctAnswer": 0,
      "conceptId": "discount_final_price_25pct",
      "variantIndex": 9,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.73,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "25% korting op €80", "content": "25% = een kwart. €80 ÷ 4 = €20 korting. Nieuwe prijs = €80 − €20 = €60.", "icon": "lightbulb" } }
      ],
      "feedback": {
        "explanationText": "De schoenmaker berekent: 25% = een kwart, dus deel door 4. 25% van €80 = €80 ÷ 4 = €20 korting. Nieuwe prijs = €80 − €20 = €60.",
        "solutionSteps": ["25% = een kwart = delen door 4", "€80 ÷ 4 = €20 korting", "Nieuwe prijs = €80 − €20 = €60"],
        "distractorExplanations": {
          "0": "Goed! €80 − 25% = €80 − €20 = €60.",
          "1": "Je dacht waarschijnlijk dat €20 de nieuwe prijs is. Maar €20 is de korting, niet wat je betaalt. Je betaalt €80 − €20 = €60. Onthoud: korting aftrekken van de originele prijs.",
          "2": "Je dacht waarschijnlijk dat je optelt. Maar bij korting trek je af: €80 − €20 = €60, niet €80 + €25 = €105. Onthoud: korting = aftrekken.",
          "3": "Je dacht waarschijnlijk dat de korting €25 is. Maar 25% van €80 = €20, niet €25. Onthoud: 25% = delen door 4."
        }
      }
    },
    {
      "id": "TGL-GELD-KORTING-010",
      "familyId": "TGL-GELD-KORTING",
      "module": "TijdGeld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_korting",
      "questionType": "multiple_choice",
      "question": "Een speelgoedwinkel geeft 20% korting op een speelgoedauto van €35. Hoeveel korting krijg je?",
      "options": ["€7", "€28", "€20", "€15"],
      "correctAnswer": 0,
      "conceptId": "discount_amount_20pct_odd",
      "variantIndex": 10,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "20% van €35", "content": "20% = een vijfde. €35 ÷ 5 = €7 korting.", "icon": "lightbulb" } }
      ],
      "feedback": {
        "explanationText": "De speelgoedwinkel berekent: 20% = een vijfde, dus deel door 5. 20% van €35 = €35 ÷ 5 = €7 korting.",
        "solutionSteps": ["20% = een vijfde = delen door 5", "€35 ÷ 5 = €7 korting"],
        "distractorExplanations": {
          "0": "Goed! 20% van €35 = €35 ÷ 5 = €7.",
          "1": "Je dacht waarschijnlijk dat de vraag naar de nieuwe prijs vraagt. Maar €28 is de prijs na korting (€35 − €7). De vraag vraagt hoeveel korting: €7. Onthoud: lees goed wat de vraag vraagt.",
          "2": "Je dacht waarschijnlijk dat het percentage gelijk is aan het bedrag. Maar 20% van €35 = €7, niet €20. Onthoud: 20% = delen door 5.",
          "3": "Je dacht waarschijnlijk dat de korting groter is. Maar 20% van €35 = €7, niet €15. Onthoud: 20% = delen door 5."
        }
      }
    },
    {
      "id": "TGL-GELD-KORTING-011",
      "familyId": "TGL-GELD-KORTING",
      "module": "TijdGeld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_korting",
      "questionType": "multiple_choice",
      "question": "Een telefoonwinkel geeft 15% korting op een telefoon van €200. Wat is de nieuwe prijs?",
      "options": ["€170", "€30", "€230", "€185"],
      "correctAnswer": 0,
      "conceptId": "discount_final_price_15pct_large",
      "variantIndex": 11,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "15% korting op €200", "content": "10% van €200 = €20. 5% = €10. Totaal: 15% = €30 korting. Nieuwe prijs = €200 − €30 = €170.", "icon": "lightbulb" } }
      ],
      "feedback": {
        "explanationText": "De telefoonwinkel berekent: splits 15% in 10% + 5%. 10% van €200 = €20. 5% = helft van 10% = €10. Totaal: 15% = €20 + €10 = €30 korting. Nieuwe prijs = €200 − €30 = €170.",
        "solutionSteps": ["10% van €200 = €20", "5% = helft van 10% = €10", "15% = €20 + €10 = €30 korting", "Nieuwe prijs = €200 − €30 = €170"],
        "distractorExplanations": {
          "0": "Goed! €200 − 15% = €200 − €30 = €170.",
          "1": "Je dacht waarschijnlijk dat €30 de nieuwe prijs is. Maar €30 is de korting, niet wat je betaalt. Je betaalt €200 − €30 = €170. Onthoud: korting aftrekken van de originele prijs.",
          "2": "Je dacht waarschijnlijk dat je optelt. Maar bij korting trek je af: €200 − €30 = €170, niet €200 + €30 = €230. Onthoud: korting = aftrekken.",
          "3": "Je dacht waarschijnlijk dat 15% = €15. Maar 15% van €200 = €30, niet €15. Onthoud: splits 15% in 10% + 5%."
        }
      }
    },
    {
      "id": "TGL-GELD-KORTING-012",
      "familyId": "TGL-GELD-KORTING",
      "module": "TijdGeld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_korting",
      "questionType": "multiple_choice",
      "question": "Een concertorganisator verhoogt de ticketprijs met 20% opslag. Een ticket kostte €50. Wat is de nieuwe prijs?",
      "options": ["€60", "€10", "€40", "€70"],
      "correctAnswer": 0,
      "conceptId": "surcharge_20pct",
      "variantIndex": 12,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.71,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "20% opslag op €50", "content": "20% van €50 = €10 opslag. Nieuwe prijs = €50 + €10 = €60. Bij opslag tel je erbij op.", "icon": "lightbulb" } }
      ],
      "feedback": {
        "explanationText": "De concertorganisator berekent: bij opslag tel je het percentage erbij op. 20% = een vijfde, dus deel door 5. 20% van €50 = €50 ÷ 5 = €10 opslag. Nieuwe prijs = €50 + €10 = €60.",
        "solutionSteps": ["20% van €50 = €50 ÷ 5 = €10 opslag", "Bij opslag tel je erbij op", "Nieuwe prijs = €50 + €10 = €60"],
        "distractorExplanations": {
          "0": "Goed! €50 + 20% = €50 + €10 = €60.",
          "1": "Je dacht waarschijnlijk dat €10 de nieuwe prijs is. Maar €10 is de opslag, niet wat je betaalt. Je betaalt €50 + €10 = €60. Onthoud: opslag optellen bij de originele prijs.",
          "2": "Je dacht waarschijnlijk dat je aftrekt. Maar bij opslag (prijsverhoging) tel je erbij op: €50 + €10 = €60, niet €50 − €10 = €40. Onthoud: opslag = optellen.",
          "3": "Je dacht waarschijnlijk dat 20% meer is. Maar 20% van €50 = €10, niet €20. Onthoud: 20% = delen door 5."
        }
      }
    }
  ]
}